import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Local from '../../Local/Local';
import { useQueryTheme } from '../../../hooks/API/useQueryThemes';
import { NAMESPACES } from '../../../constants/namespaces';

const GameCardsLineThemeTitle = ({ title, titleTemplate, themeId }) => {
  const { data } = useQueryTheme(themeId, {
    enabled:
      (Boolean(themeId) && titleTemplate && !title) ||
      (!titleTemplate && !title),
  });

  if (title && titleTemplate) {
    return <Local values={{ title }}>{titleTemplate}</Local>;
  }

  if (title && !titleTemplate) {
    return <Local namespace={NAMESPACES.THEME}>{title}</Local>;
  }

  const themeName = data?.translationKey ?? '';

  if (!title && titleTemplate) {
    return <Local values={{ title: themeName }}>{titleTemplate}</Local>;
  }

  return <Local namespace={NAMESPACES.THEME}>{themeName}</Local>;
};

GameCardsLineThemeTitle.propTypes = {
  title: PropTypes.string,
  titleTemplate: PropTypes.string,
  themeId: PropTypes.string,
};

export default memo(GameCardsLineThemeTitle);
